import type { OverviewMapRepository } from '../../application/OverviewMapRepository'
import type { OverviewMapQueryMeta } from '../../domain/overviewMapPoint'
import {
  overviewMapFixtureLostPoint,
  overviewMapFixtureNoCoordinates,
  overviewMapFixturePoints,
} from './overviewMapFixtures'

export function createFixtureOverviewMapRepository(
  source: OverviewMapQueryMeta['source'] = 'fixtures',
): OverviewMapRepository {
  return {
    load(filters) {
      const points = [...overviewMapFixturePoints]
      if (filters.includeLost) points.push(overviewMapFixtureLostPoint)
      const season = filters.season ?? '2026-2027'
      const inSeason = points.filter((point) => {
        if (point.category !== 'GREEN') return true
        return point.season ? point.season === season : true
      })
      return Promise.resolve({
        season,
        categoriesVisible: {
          green: true,
          yellow: true,
          blue: true,
          orange: true,
          opened: true,
          draft: true,
          suspended: true,
          expired: true,
          cancelled: true,
          notInterested: true,
        },
        points: inSeason,
        noCoordinatesCount: {
          green: overviewMapFixtureNoCoordinates.length,
          yellow: 0,
          blue: 0,
          orange: 0,
          opened: 0,
          draft: 0,
          suspended: 0,
          expired: 0,
          cancelled: 0,
          notInterested: 0,
        },
        noCoordinatesRecords: overviewMapFixtureNoCoordinates,
        computedAt: new Date().toISOString(),
        meta: { source, retrievedAt: new Date().toISOString() },
      })
    },
  }
}
